module.exports = __webpack_public_path__ + "static/media/11.f46c6894.svg";